import React, {useEffect} from "react";
import {useLazyGetBranchesQuery} from "../../store/api/branchApi";
import {useLazyGetCouriersQuery} from "../../store/api/courierApi";
import {useLazyGetOrdersQuery} from "../../store/api/orderApi";
import {LOCAL_STORAGE_ENTERED_TIME, LOCAL_STORAGE_MAIN_BRANCH_ID} from "../../utils/constants/LocalStorage";
import {useDispatch} from "react-redux";
import {updateMainBranch} from "../../store/api/AuthSlice";
import Loader from "../../components/loader/Loader";
import {useLocalStorage} from "../../utils/Extensions";
import {BRANCH_RELOAD_PERIOD_IN_MILLISECONDS} from "../../utils/constants/Branch";
import {PERMISSION_ADMIN} from "../../utils/constants/Constants";
import {useAuth0} from "@auth0/auth0-react";
import useAutomationWebsocket from "../../hooks/websocket/useAutomationWebsocket";

interface ApplicationProviderProps {
    children?: React.ReactNode
}

const ApplicationDataProvider: React.FC<ApplicationProviderProps> = ({children}) => {

    const [getBranches, {
        data: branches,
        isLoading: branchesLoading,
    }] = useLazyGetBranchesQuery()
    const [getCouriers, {isFetching: couriersLoading}] = useLazyGetCouriersQuery()
    const [getOrders, {isFetching: ordersLoading}] = useLazyGetOrdersQuery()
    const {value, setValue} = useLocalStorage<string>(LOCAL_STORAGE_MAIN_BRANCH_ID)
    const {setValue: setEnteredTime} = useLocalStorage<number>(LOCAL_STORAGE_ENTERED_TIME)
    const dispatch = useDispatch()
    const {user} = useAuth0()
    // Mounted here, not in the map, so the branch is checked on every page.
    useAutomationWebsocket()

    useEffect(() => {
        getBranches()
        setEnteredTime(new Date().getTime())
        setInterval(() => {
            getBranches()
        }, BRANCH_RELOAD_PERIOD_IN_MILLISECONDS)
    }, []);


    useEffect(() => {
        const isAdmin = user && (user["/roles"] as string[] | null)?.find(it => it === PERMISSION_ADMIN)
        const firstBranch = branches
            ?.data
            ?.filter(item => isAdmin || item.is_owner)
            ?.at(0)

        if (firstBranch) {
            let mainBranch = branches?.data?.filter(item => item.iikoId === value)?.at(0)
            if (!value || !mainBranch) {
                setValue(firstBranch?.iikoId)
                dispatch(updateMainBranch(firstBranch))
                mainBranch = firstBranch
            } else {
                dispatch(updateMainBranch(mainBranch))
            }
            getCouriers({branchId: mainBranch.iikoId})
            getOrders({branchId: mainBranch.iikoId})
        }
    }, [branches])

    if (branchesLoading || couriersLoading || ordersLoading) return <Loader/>


    return <>{children}</>

}

export default ApplicationDataProvider